import { ChangeStage, ChangeStageComment, PipelineInfo, PipelineRequest, Stage, StageInfo } from "../types/pipeline";
import { apiSlice } from "./baseQuery";
import { EndpointTags, PipelineEndpointTags } from "./utils";

const BASE_URL = "/api/pipeline";

export const pipelineApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getPipelineInfo: build.query<PipelineInfo, string>({
            query: (estado: string) => {
                const queryString = new URLSearchParams({ "estado": estado });
                return BASE_URL + `?${queryString}`;
            },
            keepUnusedDataFor: 0,
            providesTags: [PipelineEndpointTags.GET_PIPELINE_INFO],
        }),
        changeDealStage: build.mutation<void, ChangeStage & ChangeStageComment>({
            query: (stageData: ChangeStage & ChangeStageComment) => ({
                url: BASE_URL + "/change-stage",
                method: "POST",
                body: {...stageData},
            }),
            invalidatesTags: ["getEmpresaById", "getEmpresaInfoById", EndpointTags.GET_CURRENT_DEAL],
        }),
        getStages: build.query<StageInfo[], number>({
            query: (pipelineId: number) => BASE_URL + `/${pipelineId}/stages`
        }),
        updateStage: build.mutation<void, Stage>({
            query: (stage: Stage) => ({
                url: BASE_URL + `/stage/${stage.id}`,
                method: "PUT",
                body: {
                    nombre: stage.nombre,
                    enableRottingIn: stage.enableRottingIn,
                    rottingInDays: stage.rottingInDays,
                }
            }),
        }),
        updatePipeline: build.mutation<void, PipelineRequest>({
            query: (pipeline: PipelineRequest) => ({
                url: BASE_URL + `/${pipeline.pipelineId}`,
                method: "PUT",
                body: { defaultStage: pipeline.defaultStage }
            }),
        }),
    })
});

export const { 
    useGetPipelineInfoQuery,
    useChangeDealStageMutation,
    useGetStagesQuery,
    useUpdateStageMutation,
    useUpdatePipelineMutation,
} = pipelineApi;